import { BasicIcon, BasicIconsType } from "@pickit/pickit-components";
import { t } from "i18next";
import React, { useCallback } from "react";
import FlowTransition from "../../../../components/FlowTransition/FlowTransition";
import { FlowTrasitionParamsType } from "../../../../components/FlowTransition/types";
import FirstPage from "./FirstPage/FirstPage";
import { RoadSafetyTabProps } from "./types";
import { TABS_ICONS } from "pages/Home/components/Faq/types";
import FaqTab from "pages/Home/components/Faq/components/FaqTab/FaqTab";
import "../OperateTab/operateTab.scss";

const PAGES = {
  Bicycles: "Bicycles",
  Motorcycles: "Motorcycles",
  Cars: "Cars",
  GeneralInfo: "GeneralInfo",
  Initial: "Initial",
};
const PagesOrder = [PAGES.Bicycles, PAGES.Motorcycles, PAGES.Cars, PAGES.GeneralInfo];

const RoadSafetyTab: React.FC<RoadSafetyTabProps> = ({
  back,
  backPage,
  initialSubSection,
  initialQuestion,
  firstRender,
  setFirstRender,
}) => {
  const currentInitialQuestion = firstRender ? initialQuestion : undefined;

  const handleClick = useCallback(
    (page: string) => () => {
      back(page);
      if (setFirstRender) setFirstRender();
    },
    [back, setFirstRender]
  );

  return (
    <div>
      <div>
        <button className="mobile-option active">
          <div>
            <BasicIcon
              name={TABS_ICONS.RoadSafety as BasicIconsType}
              color="#0098ff"
            />
            <p>{t("RoadSafety:title") as string}</p>
          </div>
          <BasicIcon name="x" clickable onClick={handleClick(backPage)} />
        </button>
      </div>

      <FlowTransition
        pages={{
          [PAGES.Initial]: (props: FlowTrasitionParamsType) => (
            <FirstPage
              {...props}
              bicycles={PAGES.Bicycles}
              motorcycles={PAGES.Motorcycles}
              cars={PAGES.Cars}
              generalInfo={PAGES.GeneralInfo}
            />
          ),
          [PAGES.Bicycles]: (props: FlowTrasitionParamsType) => (
            <FaqTab
              {...props}
              tab="Bicycles"
              backPage={PAGES.Initial}
              initialQuestion={currentInitialQuestion}
              setFirstRender={setFirstRender}
            />
          ),
          [PAGES.Motorcycles]: (props: FlowTrasitionParamsType) => (
            <FaqTab
              {...props}
              tab="Motorcycles"
              backPage={PAGES.Initial}
              initialQuestion={currentInitialQuestion}
              setFirstRender={setFirstRender}
            />
          ),
          [PAGES.Cars]: (props: FlowTrasitionParamsType) => (
            <FaqTab
              {...props}
              tab="Cars"
              backPage={PAGES.Initial}
              initialQuestion={currentInitialQuestion}
              setFirstRender={setFirstRender}
            />
          ),
          [PAGES.GeneralInfo]: (props: FlowTrasitionParamsType) => (
            <FaqTab
              {...props}
              tab="GeneralInfo"
              backPage={PAGES.Initial}
              initialQuestion={currentInitialQuestion}
              setFirstRender={setFirstRender}
            />
          ),
        }}
        firstPage={
          initialSubSection
            ? PagesOrder[initialSubSection]
            : PAGES.Initial
        }
        indexPage={PAGES.Initial}
        isOpen
      />
    </div>
  );
};

export default RoadSafetyTab;
